import React from "react"


export default function MedSquare({size,img,i,onClick}) {
    return(
        <p className ={size}  onClick = {onClick}>
           {img ? <img id = {i} className ="sqImg" src ={img}></img> : null} 
        </p>
    )
}